import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
export function DoSomeMartialArtsFirstVisit() {
  return <section className="py-24 bg-ink text-off-white" data-id="element-937">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-938">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-939">
          <div className="inline-flex items-center gap-2 bg-storm-red text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-940">
            <Compass className="w-3.5 h-3.5" data-id="element-941" />
            Your First Visit
          </div>
          <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-942">
            Beginner-Friendly First Visit
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-943">
            You don't need experience, a uniform, or a fitness baseline. You
            just need to show up. Storm handles the rest.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto" data-id="element-944">
          {[{
          step: '1',
          title: 'Pick a Starting Class',
          desc: 'Fill out the form or call 517-220-0621. A Storm coach will recommend the right class based on age and goals.'
        }, {
          step: '2',
          title: 'Show Up Comfortable',
          desc: 'No uniform needed. Athletic clothes, bare feet on the mat. Arrive a few minutes early to meet the coach.'
        }, {
          step: '3',
          title: 'Learn the Basics',
          desc: 'Your first class introduces fundamentals — stance, simple kicks, etiquette. Beginner-friendly start to finish.'
        }].map((s, i) => <div key={i} className="bg-charcoal/50 border border-charcoal rounded-2xl p-6 flex flex-col gap-3" data-id="element-945">
              <div className="w-10 h-10 rounded-full bg-storm-red text-white font-bold flex items-center justify-center" data-id="element-946">
                {s.step}
              </div>
              <h3 className="text-lg text-white" data-id="element-947">{s.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-948">{s.desc}</p>
            </div>)}
        </div>

        <div className="text-center mt-10" data-id="element-949">
          <Link to="/SignMeUp" className="btn-primary" data-id="element-950">
            Start With a Trial Class
          </Link>
        </div>
      </div>
    </section>;
}